import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { api } from '../../components/api/api';
import { Alert, Pergunta, AlertErro } from '../../util/Alertas';
import { format } from 'date-fns';
import { FaBackward, FaCamera, FaDownload, FaFile, FaFolder, FaTrash } from 'react-icons/fa6';
import CameraCapture from './CameraCapture';

class ArquivoPedidoModal extends Component {
    constructor(props) {
        super(props);
        this.state = this.initState
        this.newFile = (pedidoId) => this.setState({ isNewFile: true, show: true, pedidoId: pedidoId });
        this.verFiles = (pedidoId) => {
            api.get('Arquivo/' + pedidoId, res => {
                this.setState({ pedidoId: pedidoId, Files: res.data, show: true, isNewFile: false });
            })
        };
        this.fileInputRef = React.createRef();
    }

    initState = {
        show: false,
        isNewFile: false,
        Files: [],
        pedidoId: null,
        tipoImportacao: 0
    }

    handleCloseModal = () => {
        this.setState(this.initState);
    }

    handleDrop = (acceptedFiles) => {
        this.setState((prevState) => ({
            Files: [...prevState.Files, ...acceptedFiles],
        }));
    };

    onChangeFoto = (file) => {
        this.setState((prevState) => ({
            Files: [...prevState.Files, file],
            tipoImportacao: 0
        }));
    }

    handleFileChange = (event) => {
        const files = Array.from(event.target.files);
        this.setState((prevState) => ({
            Files: [...prevState.Files, ...files],
        }));
    };

    handleDragOver = (event) => {
        event.preventDefault();
        event.dataTransfer.dropEffect = "copy";
    };

    handleDrop = (event) => {
        event.preventDefault();
        const files = Array.from(event.dataTransfer.files);
        this.setState((prevState) => ({
            Files: [...prevState.Files, ...files],
        }));
    };

    handleSubmit = () => {
        const { Files, pedidoId } = this.state;
        const data = new FormData();

        if (Files.length === 0) {
            Alert('Importe um arquivo', false, true);
            return;
        }

        for (const file of Files) {
            data.append('files', file, file.name)
        }

        api.post('Arquivo/Novo/' + pedidoId, data, res => {
            Alert('Arquivos importado com sucesso!', true);
            this.props.Reload && this.props.Reload();
            this.handleCloseModal();
        }, err => {
            AlertErro(err);
        });
    }

    render() {
        const { Files, isNewFile, show, pedidoId } = this.state;
        const { funcaoExcluir } = this.props;

        function downloadBase64File(fileName, extensao, base64Data) {
            const cleanExtensao = extensao.startsWith(".") ? extensao : `.${extensao}`;

            const link = document.createElement("a");

            const byteCharacters = atob(base64Data);
            const byteNumbers = new Uint8Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const blob = new Blob([byteNumbers], { type: "application/octet-stream" });

            link.href = URL.createObjectURL(blob);
            link.download = `${fileName}${cleanExtensao}`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        const DeletaArquivo = async (arquivoId) => {
            if (await Pergunta("Deseja realmente excluir esse arquivo?")) {
                api.post(`Arquivo/Deleta/${arquivoId}`, {}, res => {
                    this.verFiles(pedidoId);
                    Alert("Arquivo excluido com sucesso!");
                }, err => {
                    AlertErro(err, 'Houve um erro ao excluir');
                })
            }
        }

        return (
            <Modal show={show} fullscreen={!isNewFile} >
                <Modal.Header>
                    {isNewFile && 'Anexar novo arquivo'}
                    {!isNewFile && 'Arquivos do pedido #' + pedidoId}
                </Modal.Header>
                {isNewFile && <Modal.Body>

                    <div className="flex items-center gap-2  justify-center">
                        <Button onClick={() => this.setState({ tipoImportacao: 1 })} ><FaCamera /> Tirar Foto</Button>
                        <Button onClick={() => this.setState({ tipoImportacao: 2 })} variant='secondary'><FaFolder /> Buscar Em Arquivos</Button>
                    </div>

                    {this.state.tipoImportacao === 1 && <CameraCapture onChangeFoto={this.onChangeFoto}/>}
                    {this.state.tipoImportacao === 2 && <>
                        <div
                            style={{
                                border: "2px dashed #007bff",
                                padding: "20px",
                                textAlign: "center",
                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                            onDragOver={this.handleDragOver}
                            onDrop={this.handleDrop}
                            onClick={() => this.fileInputRef.current.click()}
                        >
                            <input
                                type="file"
                                multiple
                                ref={this.fileInputRef}
                                style={{ display: "none" }}
                                onChange={this.handleFileChange}
                            />
                            <p>Arraste e solte arquivos aqui, ou clique para selecionar</p>
                        </div>
                    </>}
                    {Files.length > 0 && (
                        <ul className="mt-3">
                            {Files.map((file, index) => (
                                <li key={index}>{file.name}</li>
                            ))}
                        </ul>
                    )}
                </Modal.Body>}
                {!isNewFile && <Modal.Body>
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Nome do arquivo</th>
                                <th>Extensão do arquivo</th>
                                <th>Data importação</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Files.map((file, i) => (
                                <tr key={i} className='anexos_pedido'>
                                    <td>{file.fileName}</td>
                                    <td>{file.extensao}</td>
                                    <td>{format(file.dataCadastro, "dd/MM/yyyy")}</td>
                                    <td>
                                        <button onClick={e => downloadBase64File(file.fileName, file.extensao, file.arquivo)} className='btn btn-primary'><FaDownload /></button>
                                        {funcaoExcluir && <button onClick={e => DeletaArquivo(file.arquivoId)} className='btn btn-danger'><FaTrash /></button>}
                                    </td>
                                </tr>
                            ))}
                            {Files.length === 0 && (
                                <tr>
                                    <td colSpan="8">Não foi encontrado nenhum arquivo...</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </Modal.Body>}
                <Modal.Footer>
                    {<button onClick={this.handleCloseModal} className='btn btn-success'>Voltar</button>}
                    {(isNewFile && Files.length > 0) && <button onClick={this.handleSubmit} className='btn btn-primary'>Importar</button>}
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ArquivoPedidoModal;